// removed by extract-text-webpack-plugin
module.exports = {"Conversation":"Conversation__1CM1i","ProfileImage":"ProfileImage__1B29f","ConversationItemName":"ConversationItemName__4wVLC","ConversationLastEntry":"ConversationLastEntry__3jfHI","ConversationLastEntryText":"ConversationLastEntryText__3GTB8","ConversationLastEntryTime":"ConversationLastEntryTime__3lYJk","BrandingName":"BrandingName__1ykxY","ConversationUnreadEntriesCount":"ConversationUnreadEntriesCount__5x2gD"};


//////////////////
// WEBPACK FOOTER
// ./routes/Conversations/ConversationItem/style.scss
// module id = or3P
// module chunks = 0